$('#nav-global .dropdown-menu').doubleTapToGo();

const $mainMenuItems = $('#primary-menu > .menu-item > a');
const $subnavItems = $('#primary-menu .submenu-content');
const $subnavLinks = $('#primary-menu .submenu-content > a');

function showChildren(el) {
    $subnavItems.removeClass('show');
    $(el).addClass('show');
    $('#primary-menu').addClass('showing-grandchildren');
}

if ($(window).width() > 768) {
    // We're using the desktop nav
    $mainMenuItems
        .on('mouseenter', (event) => {
            const $el = $(event.target).parent();

            // Track the hovered state in the main nav container to make changing active
            // state of nav items easier via css.
            $('#primary-menu').addClass('hovered');

            if ($el.hasClass('subnav-sidebar')) {
                // This is a mega dropdown

                // Expose the first set of grandchildren in this dropdown so they're
                // visible when it's shown
                const $firstSet = $el.find('.dropdown-submenu:first-child');
                showChildren($firstSet);
            } else {
                // $('#primary-menu').removeClass('hovered');
            }
        })
        .on('mouseleave', () => {
            $('#primary-menu').removeClass('hovered');
        });

    // Make even more listeners for the subnav containers, because bubbling mouse
    // events with absolutely positioned children is hard.
    $('.mega-dropdown-menu')
        .on('mouseenter', () => {
            $('#primary-menu').addClass('hovered');
        })
        .on('mouseleave', () => {
            $('#primary-menu').removeClass('hovered');
        });

    $subnavLinks.on('mouseenter', (event) => {
        const $el = $(event.target).parent();
        showChildren($el);
    });
    $subnavLinks.on('focus', (event) => {
        $(event.target).trigger('mouseenter');
    });

    // hide menu on mouseleave
    $('.menu-item.mega-dropdown').on('mouseleave', (e) => {
        $('.mega-dropdown > a').attr('aria-expanded', 'false');
        $('.mega-dropdown').removeClass('show');
        $('.mega-dropdown-menu').removeClass('show');
    });
} else {
    // We're using the mobile nav

    $subnavLinks.on('click', (event) => {
        const $link = $(event.target);
        const $item = $link.parent();
        const hasChildren = ($el) => $el.find('.grandchild').length > 0;

        // If this section doesn't have grandchildren, cue expand/collapse logic
        if (hasChildren($item)) {
            event.preventDefault();
            event.stopPropagation();

            if ($item.hasClass('show')) {
                // Hide it, since here we use +/-
                $item.removeClass('show');
            } else {
                showChildren($item);
            }
        }
    });
}
